import {useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {PromptsManagementService} from '../../services'
import menuStyles from '../AIManagerPage/styles.module.css'
import styles from '../PromptManagerEditPage/styles.module.css'

const SUCCESS_TOAST_STYLE = {
  background: '#16a34a',
  color: '#ffffff',
}

const ERROR_TOAST_STYLE = {
  background: '#dc2626',
  color: '#ffffff',
}

function PromptManagerCreatePage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [promptText, setPromptText] = useState('')
  const [schemaText, setSchemaText] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  const hasUnsavedChanges =
    name.trim() !== '' || promptText.trim() !== '' || schemaText.trim() !== ''

  const confirmLeaveIfNeeded = () => {
    if (!hasUnsavedChanges) return true
    return window.confirm(
      'Você possui alterações não salvas. Deseja realmente sair desta tela?',
    )
  }

  const handleSave = async () => {
    if (!name.trim()) {
      setError('O campo nome é obrigatório.')
      return
    }

    if (!promptText.trim()) {
      setError('O campo prompt é obrigatório.')
      return
    }

    let parsedSchema
    if (schemaText.trim()) {
      try {
        parsedSchema = JSON.parse(schemaText)
        if (
          parsedSchema === null ||
          Array.isArray(parsedSchema) ||
          typeof parsedSchema !== 'object'
        ) {
          setError('O campo de schema precisa conter um JSON objeto válido.')
          return
        }
      } catch {
        setError('O campo de schema precisa conter um JSON válido.')
        return
      }
    }

    setIsSaving(true)
    setError('')

    const response = await PromptsManagementService.createPrompt({
      name: name.trim(),
      prompt: promptText,
      ...(parsedSchema ? {schema: parsedSchema} : {}),
    })

    setIsSaving(false)

    if (response?.responseStatus === 200 || response?.responseStatus === 201) {
      toast.success('Prompt criado com sucesso.', {
        style: SUCCESS_TOAST_STYLE,
      })
      navigate('/PromptManagerList')
      return
    }

    const backendMessage =
      response?.response?.data?.details?.[0]?.message ||
      response?.response?.data?.message
    const errorMessage = backendMessage
      ? `Não foi possível criar o prompt: ${backendMessage}`
      : 'Não foi possível criar o prompt.'

    setError(errorMessage)
    toast.error(errorMessage, {
      style: ERROR_TOAST_STYLE,
    })
  }

  return (
    <div className={menuStyles.page}>
      <aside className={menuStyles.sideMenu}>
        <p className={menuStyles.menuTitle}>AI Manager</p>
        <Link to="/AIManager" className={menuStyles.menuLink}>
          Home Ai Manager
        </Link>
        <Link
          to="/PromptManagerList"
          className={`${menuStyles.menuLink} ${menuStyles.menuLinkActive}`}
        >
          Prompt Manager
        </Link>
        <Link to="/ChatSocket" className={menuStyles.menuLink}>
          Voltar ao sistema
        </Link>
      </aside>

      <section className={menuStyles.content}>
        <div className={menuStyles.breadcrumb}>
          <Link to="/AIManager" className={menuStyles.breadcrumbLink}>
            AI Manager
          </Link>
          <span className={menuStyles.breadcrumbSep}>/</span>
          <Link to="/PromptManagerList" className={menuStyles.breadcrumbLink}>
            Prompt Manager
          </Link>
          <span className={menuStyles.breadcrumbSep}>/</span>
          <span className={menuStyles.breadcrumbCurrent}>Criar</span>
        </div>
        <div className={styles.header}>
          <h2 className={styles.title}>Criar Novo Prompt</h2>
        </div>

        <div className={styles.form}>
          <label className={styles.label} htmlFor="prompt-name">
            Nome
          </label>
          <input
            id="prompt-name"
            className={styles.input}
            value={name}
            onChange={(event) => setName(event.target.value)}
          />

          <label className={styles.label} htmlFor="prompt-textarea">
            Prompt
          </label>
          <textarea
            id="prompt-textarea"
            className={styles.textarea}
            value={promptText}
            onChange={(event) => setPromptText(event.target.value)}
            rows={14}
          />

          <label className={styles.label} htmlFor="schema-textarea">
            Schema (JSON) - opcional
          </label>
          <textarea
            id="schema-textarea"
            className={styles.schemaTextarea}
            value={schemaText}
            onChange={(event) => setSchemaText(event.target.value)}
            rows={16}
          />

          {error ? <p className={styles.errorText}>{error}</p> : null}

          <div className={styles.actions}>
            <button
              className={styles.secondaryButton}
              type="button"
              onClick={() => {
                if (!confirmLeaveIfNeeded()) return
                navigate('/PromptManagerList')
              }}
            >
              Voltar
            </button>
            <button
              className={styles.primaryButton}
              type="button"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PromptManagerCreatePage
